import { FullWidth } from 'ui/utility/fullWidth';
import { HeaderTitle } from 'ui/pageHeader';
import { PAGE_SIZES, PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';
import { usePaginationContext } from 'utils/contexts/pagination';
import { GeneralEmptyState, NoResults } from './EmptyState';
import { SnippetIndexHeaderActions } from './SnippetIndexHeaderActions';
import { SnippetTable } from './SnippetTable';
import { SnippetModals } from './SnippetModals';
import { IndexPageContainer, IndexPageHeader } from './Styled';
import { useSnippetQueryContext } from '../context/SnippetQueryContext';
import { useSnippetFiltersContext } from '../context/SnippetFiltersContext';
import { useTranslations } from '../hooks/useTranslations';

export const SnippetIndexPage = () => {
  const { t } = useTranslations();
  const { searchQuery } = useSnippetFiltersContext();
  const { isLoading, paginationInfo, snippets: snippetList } = useSnippetQueryContext();
  const { setCurrentPage, setPageSize } = usePaginationContext();

  const hasSnippets = snippetList.length > 0;

  const handlePaginationUpdate = ({ page, pageSize }: PaginationUpdateEvent): void => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <IndexPageContainer data-test="snippet-list-page">
      <IndexPageHeader
        data-test="snippet-list-header"
        documentTitle={t('header.snippetIndexPage')}
        pageActions={<SnippetIndexHeaderActions />}
      >
        <HeaderTitle>{t('header.snippetIndexPage')}</HeaderTitle>
      </IndexPageHeader>

      <FullWidth>
        {(isLoading || hasSnippets) && <SnippetTable />}
        {!isLoading && !hasSnippets && (searchQuery ? <NoResults /> : <GeneralEmptyState />)}
        {hasSnippets && (
          <PaginationFooter
            currentPage={paginationInfo.page}
            itemsPerPage={paginationInfo.limit}
            numItems={paginationInfo.count}
            pageSizes={PAGE_SIZES}
            onUpdate={handlePaginationUpdate}
          />
        )}
      </FullWidth>

      <SnippetModals />
    </IndexPageContainer>
  );
};

export default SnippetIndexPage;
